module.exports = __webpack_public_path__ + "img/airport.3f383b5a.svg";